export const actions = [
  { id: 1, actionName: 'Remove' },
  { id: 2, actionName: 'Rename' },
];

export const rowUniqueness = [
  { id: 1, name: 'Every Row is Unique' },
  { id: 2, name: 'Row May Repeat' },
];

export const rowMatch = [
  { id: 2, name: 'Keep only Matching Row', image: '' },
  { id: 1, name: 'Keep All Rows', image: '' },
];

export const arrowType = [
  {
    id: 1,
    isSelected: false,
    name: 'One to One',
    showHead: false,
    showTail: false,
  },
  {
    id: 2,
    isSelected: false,
    name: 'One to Many',
    showHead: true,
    showTail: false,
  },
  {
    id: 3,
    isSelected: false,
    name: 'Many to One',
    showHead: false,
    showTail: true,
  },
  {
    id: 4,
    isSelected: false,
    name: 'Many to Many',
    showHead: true,
    showTail: true,
  },
];
